module.exports = __webpack_public_path__ + "img/3.d8773bb5.png";